import type { PatentPrimaryCategoryData } from "./patentPrimaryCategory.interface";

const isPatentPrimaryCategoryMap = (
  value: unknown,
): value is PatentPrimaryCategoryData => {
  if (!value || typeof value !== "object") return false;

  const firstEntry = Object.entries(value)[0];
  if (!firstEntry) return true;

  const [, item] = firstEntry;
  return (
    typeof item === "object" &&
    item !== null &&
    "displayValue" in item &&
    "viewOrder" in item
  );
};

const getPatentPrimaryCategoryMap = (
  response: unknown,
): PatentPrimaryCategoryData => {
  if (!isPatentPrimaryCategoryMap(response)) return {};

  return response;
};

const toFilterList = (map: PatentPrimaryCategoryData) =>
  Object.entries(map)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .map(([code, value]) => ({
      code,
      name: value.displayValue,
      isCheck: false,
    }));

export const adaptPatentPrimaryCategory = (response: unknown) => {
  const map = getPatentPrimaryCategoryMap(response);

  return Object.entries(map)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [code, value]) => {
      acc[code] = value.displayValue;
      return acc;
    }, {} as Record<string, string>);
};

export const adaptPatentPrimaryCategoryFilter = (response: unknown) => {
  const list = toFilterList(getPatentPrimaryCategoryMap(response));

  return {
    ai: list,
    manual: [
      ...list,
      {
        code: "",
        name: "None",
        isCheck: false,
      },
    ],
  };
};
